import http from './http.service';

class AdditionService {
    constructor() {
        if (AdditionService.instance) {
            return AdditionService.instance;
        }

        AdditionService.instance = this;
    }

    additions() {
        return http.get('/addition').then(res => res.data);
    }
    store(data) {
        return http.post('/addition/store', data).then(res => res.data);
    }
    show(additionId) {
        return http.get(`/addition/${additionId}/show`).then(res => res.data);
    }
    update(additionId, data) {
        return http.put(`/addition/${additionId}/update`, data).then(res => res.data);
    }
    reorder(eqs) {
        return http.put('/addition/reorder', eqs).then(res => res.data);
    }
    destroy(additionId) {
        return http.delete(`/addition/${additionId}/destroy`).then(res => res.data);
    }
    destroyImg(additionId) {
        return http.delete(`/addition/${additionId}/destroy-img`).then(res => res.data);
    }
    toggleActive(additionId) {
        return http.put(`/addition/${additionId}/toggle-active`).then(res => res.data);
    }
}

export default new AdditionService();
